import { useState, useRef } from 'react';

const usePullToRefresh = (onRefresh) => {
  const [pulling, setPulling] = useState(false);
  const [pullY, setPullY] = useState(0);
  const startY = useRef(0);
  const refreshing = useRef(false);

  const handlers = {
    onTouchStart: (e) => {
      if (window.scrollY === 0) startY.current = e.touches[0].clientY;
      else startY.current = 0;
    },
    onTouchMove: (e) => {
      if (!startY.current || refreshing.current) return;
      const dy = e.touches[0].clientY - startY.current;
      if (dy > 0 && dy < 120) { setPulling(true); setPullY(Math.min(dy, 80)); }
    },
    onTouchEnd: async () => {
      if (pullY > 50 && !refreshing.current) {
        refreshing.current = true;
        try { await onRefresh(); } finally { refreshing.current = false; }
      }
      setPulling(false); setPullY(0); startY.current = 0;
    }
  };
  return { handlers, pulling, pullY };
};

export default usePullToRefresh;
